var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinosOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65B4BB"
    },
    cx: 396.299,
    cy: 316.415,
    r: 108.103
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65B4BB"
    },
    d: "M225.748,171.165v145.257l-167.65-58.153l-25.341-8.797c0,0,65.922-110.628,67.83-113.713 c11.893-19.308,33.224-32.184,57.571-32.184c1.931,0,3.85,0.08,5.735,0.24C198.533,106.728,225.748,135.77,225.748,171.165z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A3A7"
    },
    d: "M163.893,103.814l-46.247,104.501l-59.548,49.954l-25.341-8.797c0,0,65.922-110.628,67.83-113.713 c11.893-19.308,33.224-32.184,57.571-32.184C160.088,103.574,162.008,103.654,163.893,103.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A3A7"
    },
    d: "M173.637,105.345c1.727-2.902,2.868-4.806,3.008-5.041c4.676-7.579,13.043-12.631,22.585-12.631 c14.653,0,26.521,11.868,26.521,26.521v56.979"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65B4BB"
    },
    cx: 117.643,
    cy: 316.415,
    r: 108.103
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A3A7"
    },
    d: "M288.193,171.173v-56.979c0-14.653,11.868-26.521,26.521-26.521c9.541,0,17.908,5.053,22.585,12.631 c0.141,0.235,1.281,2.139,3.008,5.041"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65B4BB"
    },
    d: "M481.188,249.472l-192.991,66.951V171.165c0-22.907,11.402-43.152,28.837-55.377 c10.968-7.7,24.335-12.213,38.754-12.213c24.347,0,45.677,12.876,57.571,32.184C415.266,138.843,481.188,249.472,481.188,249.472z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.747,
    y: 252.184,
    style: {
      fill: "#65B4BB"
    },
    width: 62.442,
    height: 32.902
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.747,
    y: 184.08,
    style: {
      fill: "#57A3A7"
    },
    width: 62.442,
    height: 68.116
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A3A7"
    },
    d: "M332.937,228.827l-44.74,73.428v-131.09c0-22.907,11.402-43.152,28.837-55.377L332.937,228.827z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A0DBFD"
    },
    cx: 396.299,
    cy: 316.415,
    r: 71.235
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A0DBFD"
    },
    cx: 117.643,
    cy: 316.415,
    r: 71.235
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1E9FD"
    },
    d: "M117.646,245.182c-4.291,0-8.485,0.401-12.568,1.128c33.347,5.939,58.672,35.058,58.672,70.112 s-25.325,64.173-58.672,70.112c4.082,0.727,8.276,1.128,12.568,1.128c39.344,0,71.239-31.895,71.239-71.239 C188.885,277.077,156.99,245.182,117.646,245.182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87CEE9"
    },
    d: "M117.646,387.661c4.291,0,8.485-0.401,12.567-1.128c-33.347-5.939-58.672-35.058-58.672-70.112 s25.325-64.173,58.672-70.112c-4.082-0.727-8.276-1.128-12.567-1.128c-39.344,0-71.239,31.895-71.239,71.239 S78.301,387.661,117.646,387.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87CEE9"
    },
    d: "M396.298,387.661c4.291,0,8.485-0.401,12.568-1.128c-33.347-5.939-58.672-35.058-58.672-70.112 s25.325-64.173,58.672-70.112c-4.082-0.727-8.276-1.128-12.568-1.128c-39.344,0-71.239,31.895-71.239,71.239 C325.058,355.765,356.954,387.661,396.298,387.661z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1E9FD"
    },
    d: "M396.298,245.182c-4.291,0-8.485,0.401-12.567,1.128c33.347,5.939,58.672,35.058,58.672,70.112 s-25.325,64.173-58.672,70.112c4.082,0.727,8.276,1.128,12.567,1.128c39.344,0,71.239-31.895,71.239-71.239 C467.538,277.077,435.643,245.182,396.298,245.182z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.686,131.162c-13.99-22.704-38.24-36.258-64.869-36.258c-3.799,0-7.53,0.288-11.182,0.828 c-0.003-0.007-0.013-0.022-0.016-0.026c-6.453-10.457-17.622-16.701-29.876-16.701c-19.348,0-35.09,15.741-35.09,35.09v61.312 h-45.306v-61.312c0-19.348-15.741-35.09-35.09-35.09c-12.232,0-23.38,6.221-29.89,16.727c-3.651-0.54-7.384-0.828-11.184-0.828 c-26.629,0-50.879,13.555-64.87,36.26c-0.193,0.313-0.78,1.267-14.882,24.908c-2.424,4.064-1.095,9.324,2.969,11.748 c4.064,2.423,9.324,1.096,11.748-2.969c11.604-19.452,14.43-24.168,14.757-24.699c10.846-17.602,29.642-28.111,50.279-28.111 c32.548,0,59.026,26.479,59.026,59.026v0.005v84.439c-20.53-33.481-57.467-55.864-99.536-55.864 c-18.999,0-36.95,4.568-52.817,12.657c4.075-6.837,8.38-14.06,12.7-21.304c2.423-4.065,1.093-9.325-2.972-11.748 c-4.065-2.423-9.324-1.093-11.748,2.972c-18.206,30.534-46.861,76.35-50.481,83.914C4.08,281.345,0,298.365,0,316.322 c0,64.334,52.34,116.674,116.674,116.674s116.673-52.34,116.673-116.674v-22.767h45.306v22.767 c0,64.334,52.34,116.674,116.673,116.674c64.334,0,116.674-52.34,116.674-116.674c0-18.451-4.307-35.913-11.968-51.439 C496.531,257.785,421.586,134.247,419.686,131.162z M405.095,140.153c1.028,1.669,22.444,37.584,43.048,72.152 c-15.868-8.09-33.819-12.658-52.818-12.658c-42.069,0-79.006,22.384-99.536,55.864v-84.439v-0.005 c0-32.548,26.479-59.026,59.026-59.026C375.454,112.042,394.249,122.551,405.095,140.153z M295.79,114.095 c0-9.899,8.053-17.952,17.952-17.952c4.509,0,8.729,1.665,11.956,4.56c-11.731,4.873-21.99,12.593-29.908,22.298V114.095z  M278.652,192.543v50.973h-45.306v-50.973H278.652z M186.313,100.707c3.244-2.91,7.45-4.564,11.945-4.564 c9.899,0,17.952,8.053,17.952,17.952V123C208.294,113.297,198.04,105.58,186.313,100.707z M116.674,415.857 c-54.885,0-99.537-44.651-99.537-99.536s44.652-99.537,99.537-99.537s99.536,44.652,99.536,99.537S171.558,415.857,116.674,415.857z  M233.348,276.418v-15.764h45.306v15.764H233.348z M395.327,415.857c-54.885,0-99.536-44.652-99.536-99.537 s44.652-99.537,99.536-99.537c54.885,0,99.537,44.652,99.537,99.537S450.211,415.857,395.327,415.857z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470.448,289.32c-1.602-4.452-6.508-6.765-10.962-5.164c-4.452,1.601-6.765,6.509-5.164,10.962 c2.438,6.783,3.675,13.917,3.675,21.203c0,34.557-28.113,62.671-62.671,62.671s-62.671-28.113-62.671-62.671 s28.113-62.671,62.671-62.671c17.343,0,34.069,7.286,45.891,19.989c3.224,3.464,8.645,3.659,12.111,0.435 c3.464-3.224,3.659-8.645,0.435-12.111c-15.051-16.174-36.351-25.451-58.437-25.451c-44.007,0-79.808,35.801-79.808,79.808 s35.801,79.808,79.808,79.808s79.808-35.801,79.808-79.808C475.135,307.054,473.558,297.969,470.448,289.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.674,236.514c-44.007,0-79.808,35.801-79.808,79.808s35.801,79.808,79.808,79.808s79.808-35.801,79.808-79.808 S160.68,236.514,116.674,236.514z M116.674,378.992c-34.557,0-62.671-28.113-62.671-62.671s28.113-62.671,62.671-62.671 s62.671,28.113,62.671,62.671S151.23,378.992,116.674,378.992z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinosOn);
export default __webpack_public_path__ + "static/media/binos-on.e080733360b92b5b56ad66ffa3a941e6.svg";
export { ForwardRef as ReactComponent };